import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home.tsx';
import Login from './pages/Login.tsx';
import Registration from './pages/Registration.tsx';
import ViewCoins from './pages/ViewCoins.tsx';
import Welcome from './pages/Welcome.tsx';
import Analyze from "./pages/Analyze.tsx";
import ProtectedRoute from "./components/ProtectedRoute.tsx";

function App() {
  return (
    <Router>
      <Routes>
        {/* PUBLIC */}
        <Route path="/" element={<Welcome />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Registration />} />

        {/* PROTECTED */}
        <Route path="/home" element={<ProtectedRoute><Home /></ProtectedRoute>} />
        <Route path="/view-coins" element={<ProtectedRoute><ViewCoins /></ProtectedRoute>} />
        <Route path="/analyze/:id" element={<ProtectedRoute><Analyze /></ProtectedRoute>} />
      </Routes>
    </Router>
  );
}

export default App;